export default {
      id: "angleLeft-usage",
      viewBox: "0 0 14 14",
      url: "assets/" + "sprite.svg#angleLeft-usage",
      toString: function () {
        return this.url;
      }
    }